if (!global._babelPolyfill) {
    require('babel-polyfill')
};

import React from "react";
import { connect } from "react-redux";
// let browserHistory = require('react-router').browserHistory

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");

export class ViewNotesModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            important: this.props.upload.creator.important_note
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.result.actionType ===
            actionTypes.SAVE_CREATOR_NOTE_SUCCESS
        ) {
            this.props.dismissModal();
        }
    }

    dismissModal(e) {
        if (e) e.preventDefault();

        this.props.dismissModal();
    }

    render() {
        return (
            <div
                className={
                    "react-modal full-transparent moderation-modal-background save-for-later-modal"
                }
            >
                <a
                    href="#"
                    className="modal-background-closer"
                    onClick={this.dismissModal.bind(this)}
                />
                <div className={"inner-modal"}>
                    <a
                        href="#"
                        onClick={this.dismissModal.bind(this)}
                        title="close"
                        className="ui_close"
                    />
                    <div className="modal-content">
                        <div className="save-for-later-clock ui_notes yellow" />
                        <h3 className="modal-title">{"Note about Creator"}</h3>
                        <div className="notes-section gray">
                            <span>
                                <textarea
                                    placeholder="Write something here..."
                                    ref="creatorNote"
                                    defaultValue={
                                        this.props.upload.creator.notes
                                    }
                                    style={{ height: "200px" }}
                                />
                            </span>
                            <div
                                className="save-as-important"
                                style={{ margin: "20px 0 0", fontSize: "20px" }}
                            >
                                <label htmlFor="saveAsImportant">
                                    Mark as important
                                    <input
                                        type="checkbox"
                                        name="saveAsImportant"
                                        ref="saveAsImportant"
                                        onChange={this.setImportant.bind(this)}
                                        checked={this.state.important}
                                        style={{
                                            marginLeft: "20px",
                                            height: "16px"
                                        }}
                                    />
                                </label>
                            </div>
                        </div>
                        <button
                            className="btn btn-default yellow"
                            onClick={this.saveCreatorNote.bind(this)}
                        >
                            {"Save"}
                        </button>
                        <div className="cancel-btn">
                            <a
                                className="text-link"
                                onClick={this.dismissModal.bind(this)}
                            >
                                {"Cancel"}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    saveCreatorNote() {
        let creator = Object.assign({}, this.props.upload.creator),
            note = this.refs["creatorNote"],
            important = this.state.important;

        if (note) {
            creator.note = note.value;
            this.props.saveCreatorNote(creator, important);
        }
    }

    setImportant(e) {
        let important = this.state.important;

        if (this.state.important) {
            important = false;
        } else {
            important = true;
        }

        this.setState({
            important: important
        });
    }
}

export default connect(null, {
    saveCreatorNote: actions.saveCreatorNote
})(ViewNotesModal);
